// src/contracts/components/StatusPill.js
import React from 'react';

const styles = {
  Draft:     { color: 'text-zinc-400',   border: 'border-zinc-700',  dot: 'bg-zinc-500',  label: 'Draft' },
  Saving:    { color: 'text-amber-300',  border: 'border-amber-700', dot: 'bg-amber-400 animate-pulse', label: 'Saving…' },
  Saved:     { color: 'text-emerald-300',border: 'border-emerald-700', dot: 'bg-emerald-400', label: 'Saved' },
  Sent:      { color: 'text-indigo-200', border: 'border-indigo-600', dot: 'bg-indigo-400', label: 'Sent' },
  Signed:    { color: 'text-emerald-200',border: 'border-emerald-600', dot: 'bg-emerald-400', label: 'Signed' },
  Cancelled: { color: 'text-red-300',    border: 'border-red-700', dot: 'bg-red-400', label: 'Cancelled' },
};

export default function StatusPill({ value }) {
  const s = styles[value] || styles.Draft;
  return (
    <span className={`inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border ${s.border} ${s.color}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
